export default "assets/images/pairing-c98d8a97.svg";